import axios from "axios";
import { getBase } from "./common.js";
let baseURL = getBase();
const http = () => {
  return axios.create({
    baseURL,
  });
};
export default http();
